import { t } from 'i18next';
import '../../Style/home/select.css';
function SelectSection({objectDto, setObjectDto}){
    const stepData = [
        { number: 1, name: t("homestep1") },
        { number: 2, name: t("homestep2") },
        { number: 3, name: t("homestep3") },
        { number: 4, name: t("homestep4") },
      ];
    const listObj = [{title: "Phú Bảo An Gia 2.0", desc: "Bảo vệ toàn diện trước 10 bệnh hiểm nghèo"},
        // {title: "Phú Bảo An Gia 3.0", desc: "Bảo vệ toàn diện trước 20 bệnh hiểm nghèo"},
        // {title: "Phú Bảo An Gia 4.0", desc: "Bảo vệ toàn diện trước 30 bệnh hiểm nghèo"},
        // {title: "Phú Bảo An Gia 5.0", desc: "Bảo vệ toàn diện trước 40 bệnh hiểm nghèo"}
    ]
    const handleClick = (item) => {
        setObjectDto({...objectDto, step: 0});
        window.scrollTo(0,0);
    }
    return (
        <section className="select-section">
            <h2 className="title-font-select product-title-label">{t("homesteptitle")}</h2>
            <div className="steps-container">
                {
                    stepData.map((step, index) => (
                        <div className="step-wrapper" key={index}>
                            <div className="step">
                                <div className="circle circle-home">{step.number}</div>
                                <p className="step-name step-home">{step.name}</p>
                            </div>
                            {
                                index < stepData.length - 1 && <div className="line line-home"></div>
                            }
                        </div>
                    ))
                }
            </div>
            
            <h2 className="title-font-select product-title-label">{t("homelistproducttitle")}</h2>
            <div className='product-select-container'>
                {listObj.map((item, index)=>{
                    return (
                        <div className="product-select-section" style={{cursor: "pointer"}} key={index}>
                            <div className="product-image-placeholder" onClick={handleClick}/>
                            <h3 className='product-select-section-h3 home-title-list-product'>{item.title}</h3>
                            <p className='product-select-section-p home-desc-list-product'>{item.desc}</p>
                        </div>
                    )
                })}
            </div>
        </section>
    );
}
export default SelectSection;